export default __webpack_public_path__ + "static/media/green-tick-icon.50fc2147.svg";